import { RouteComponentProps } from "../../../../models/RouteComponent";
import { CardActions, CardOverflow, Typography } from "@mui/joy";
import { Button } from "primereact/button";
import useApiService from "../../../../hooks/useApiService";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { PoliciesProceduresRecord } from "../../../../models/DSF/PoliciesAndProcedures";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { formatDate } from "../../../../utils/DateUtils";
import "./styles.scss";

function PoliciesProcedures(props: RouteComponentProps) {
  const { session } = props;
  const toast = useRef<any>(null);
  const [selectedPolicy, setSelectedPolicy] = useState<PoliciesProceduresRecord | null>(null);
  const { data, error, loading } = useApiService<PoliciesProceduresRecord[]>({
    method: "GET",
    url: "site-policies-procedures",
    apiName: "open",
    params: {
      clientId: session.client_id,
      siteId: session.site_id,
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loading);
  }, [loading]);

  useEffect(() => {
    if (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Could not load site policies and procedures",
      });
    }
  }, [error]);

  const displayUpdatedOn = (data: PoliciesProceduresRecord) => {
    return <>{formatDate(data.updated_at, "short")}</>;
  };

  const displayCreatedOn = (data: PoliciesProceduresRecord) => {
    return <>{formatDate(data.created_at, "short")}</>;
  };

  return (
    <>
      <Typography level="h2" component="h1">
        Policies and Procedures
      </Typography>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15, marginBottom: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Download PDF"
            className="p-button-outlined"
            size="small"
            disabled={true}
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => {}}
          />
        </CardActions>
      </CardOverflow>
      {data && (
        <div className={"custom-data-table"}>
          <DataTable
            value={data}
            tableStyle={{ minWidth: "50rem" }}
            onRowClick={e => {
              setSelectedPolicy(e.data as PoliciesProceduresRecord);
            }}
            className="policies-procedures-table"
          >
            <Column field={"name"} header={"Name"} sortable={false} />
            <Column field={"Updated on"} header={"Updated on"} body={displayUpdatedOn} sortable />
            <Column field={"Created on"} header={"Created on"} body={displayCreatedOn} sortable />
          </DataTable>
        </div>
      )}
      <Dialog
        visible={!!selectedPolicy}
        onHide={() => setSelectedPolicy(null)}
        header={selectedPolicy?.name}
        style={{ width: "60vw" }}
      >
        <div dangerouslySetInnerHTML={{ __html: selectedPolicy?.content || "" }} />
      </Dialog>
      <Toast ref={toast} />
    </>
  );
}

export default PoliciesProcedures;
